import { Component, OnInit, Input } from '@angular/core';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Config } from '../../../config/config';
import { Router } from '@angular/router';
import { AppService, DomainDetails } from 'src/app/app.service';
import * as L from 'leaflet';
import 'leaflet-compass';
@Component({
  selector: 'app-public-aqi-map-dashboard',
  templateUrl: './public-aqi-map-dashboard.component.html',
  styleUrls: ['./public-aqi-map-dashboard.component.scss']
})
export class PublicAqiMapDashboardComponent implements OnInit {
  @Input() landingPage: any;
  public domainDetails: DomainDetails;
  public Object = Object;
  public layerType: any = 'AQI';
  public markers: any = [];
  public standards: any;
  public markerData: any;
  public selectedMarkerInfo: any;
  public lng = 25.57512; // 25.143643; // To Display default latitude
  public lat = 55.959278; // 56.323126; // To Display default longitude
  public zoom = 8;
  // public lat = 25.735;
  // public lng = 56.140833;
  public geoJsonObject;
  public dataTableOptions: any = {
    pageLength: 10,
    order: [],
    columnDefs: [],
    paging: true,
    ordering: true,
    info: false
  };
  public activeTab: any = 'info';
  public tabs = [
    { key: 'info', label: 'Info' },
    { key: 'hourly', label: 'Hourly Average' }
  ];
  public lenLat;
  public staticJson;
  public standardsMapping;
  public aqiLayerTypes;
  public isAqiLayers;
  public leafLetMap: any;

  constructor(
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public router: Router,
    public appService: AppService
  ) { }

  ngOnInit() {
    this.staticJson = this.appService.constants.staticRequestJson;
    this.standardsMapping = this.appService.constants.AQI_STANDARDS;
    this.aqiLayerTypes = this.appService.constants.AQI_LAYER_TYPES;
    this.domainDetails = this.appService.DOMAIN_DETAILS();
    // this.loadMap();
    this.fetchAQIMetrics();
    this.loadGeoJson();
    this.isAqiLayersFn();
  }

  initMapLeaflet() {
    try {
      if (this.leafLetMap) {
        this.leafLetMap.remove();
      }
      var container: any = L.DomUtil.get('leafLetMap');
      if (container != null) {
        container._leaflet_id = null;
      }
      let that = this;
      this.leafLetMap = L.map('leafLetMap').setView([this.lat, this.lng], 9);

      // Normal Map View
      // const wmsLayerOptions: any = {
      //   layers: 'vehiTrack',
      //   service: 'WMS',
      //   version: '1.1.1',
      //   request: 'GetMap',
      //   styles: '',
      //   format: 'image/png',
      //   minZoom: 7,
      // };
      // L.tileLayer.wms(Config.CONSTANTS.LEAFLETTILES, wmsLayerOptions as L.WMSOptions).addTo(this.leafLetMap);
      // L.geoJson(this.geoJsonObject, { style: { color: 'grey' } }).addTo(this.leafLetMap);
      // 

      // Satellite View
      // const esriLayer = L.tileLayer(
      //   'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      //   {
      //     attribution: 'Tiles © Esri',
      //     // maxZoom: 20,
      //     minZoom: 7,
      //   }
      // );

      const esriLayer = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&hl=tr&x={x}&y={y}&z={z}', {
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        maxNativeZoom: 21,
        zIndex: 0,
        maxZoom: 21
      })
      
      esriLayer.addTo(this.leafLetMap);
      L.geoJson(this.geoJsonObject, { style: { color: '#333' } }).addTo(this.leafLetMap);
      // 

      // Add the compass control
      (L.control as any).compass({
        autoActive: true,
        // showDigit: true,
        position: 'topleft'
      }).addTo(this.leafLetMap);
      //

      this.loadMapLeafLet()
      setTimeout(() => {
        this.leafLetMap.invalidateSize(true);
      }, 300);
    } catch (error) {
      console.error(error);
    }
  }

  public leafLetMarkers: any = []
  loadMapLeafLet() {
    this.leafLetMarkers = [];
    let payLoad = { pollutant: 'AQI', state: 'Ras Al Khaimah', layerType: this.layerType };
    if (this.landingPage) {
      payLoad = Object.assign(this.staticJson, payLoad);
    }
    try {
      const request: RequestPayLoadFormat = {
        api: 'publicAqiMap',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        var data: any = []
        if (response.status && response.station_list.length) {
          this.leafLetMarkers = [];
          this.leafLetMarkers = response.station_list;
          data = response.station_list;

          // Add markers to the map
          data.forEach(data => {
            var customIcon = this.createCustomIcon(data, data.remark);
            var marker = L.marker([data.latitude, data.longitude], { icon: customIcon }).addTo(this.leafLetMap);

            var popupContent: any = `
            <div class="row">
            <div class="col-5">SiteName</div>
            <div class="col-1">:</div>
            <div class="col-6"><b>${data.site_name}</b></div>
            `
            // Popup content
            if (this.layerType === 'AQI') {
              popupContent += `
                <div class="col-5">Responsible Parameter</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.responsibleParam}</b></div>
                <div class="col-5">AQI</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.aqi}</b></div>
              `
            }
            else if (this.layerType === 'BARPRESS') {
              popupContent += `
                <div class="col-5">BARPRESS</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.aqiBP}</b></div>
              `
            }
            else if (this.layerType === 'WIND') {
              popupContent += `
                <div class="col-5">Wind Speed</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.aqiWS}</b></div>
                <div class="col-5">Wind Direction</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.aqiWD}</b></div>
                `
            }
            else if (this.layerType === 'SWDR') {
              popupContent += `
                <div class="col-5">Wind Speed</div>
                <div class="col-1">:</div>
                <div class="col-6"><b>${data.aqiWS}</b></div>
              `
              popupContent += `</div>`
            }
            marker.on('mouseover', (event) => {
              marker.bindPopup(popupContent).openPopup();
            });

            // Mouseout event handler (optional)
            marker.on('mouseout', (event) => {
              marker.closePopup();
            });
            marker.on('click', (event) => {
              this.mapMarkerClick(data);
            });
          });
          this.leafLetMarkers = data
        } else {
          this.sharedService.serviceErrorMessage(response.message || 'No Data Available');
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }

  createCustomIcon(data: any, remark: any) {
    let icon: any = {};
    let angle: any = []
    if (this.layerType === 'WIND') {
      angle = data.aqiWD.split(" ")
    }
    let rotationAngle: any = 0;
    switch (remark) {
      case 'Good':
        icon.url = 'assets/images/markers/value-good.png';
        break;
      case 'Moderate':
        icon.url = 'assets/images/markers/value-moderate.png';
        break;
      case 'Unhealthy for Sensitive Groups':
        icon.url = 'assets/images/markers/value-satisfactory.png';
        break;
      case 'Unhealthy':
        icon.url = 'assets/images/markers/value-poor.png';
        break;
      case 'Very Unhealthy':
        icon.url = 'assets/images/markers/value-verypoor.png';
        break;
      case 'Hazardous':
        icon.url = 'assets/images/markers/value-severe.png';
        break;
      case 'NA':
        if (this.layerType === 'WIND') {
          icon.url = 'assets/images/markers/arrow_original.png';
          rotationAngle = angle[0] - 180 || 0
        } else if (this.layerType === 'BARPRESS' || this.layerType === 'SWDR') {
          icon.url = 'assets/images/markers/value-moderate.png';
        } else {
          icon.url = 'assets/images/markers/value-NA.png';
        }
        break;
      default:
        icon.url = 'assets/images/markers/value-NA.png';
        break;
    }

    const markerWidthFactor: any = 2.3;
    const tempDiv = document.createElement('div');
    tempDiv.style.fontSize = '0.6rem';
    tempDiv.style.position = 'absolute';
    tempDiv.innerText = this.layerType === 'AQI' ? data.aqi : (this.layerType === 'BARPRESS' ? data.aqiBP : (this.layerType === 'SWDR' ? data.aqiWS : ''));
    document.body.appendChild(tempDiv);
    const textWidth = tempDiv.offsetWidth;
    document.body.removeChild(tempDiv);
    const adjustedWidth = (textWidth * markerWidthFactor) < 35 ? 35 : textWidth * markerWidthFactor;

    return L.divIcon({
      className: 'custom-marker',
      iconSize: [32, 32],
      html: `<img src="${icon.url}" alt="Marker" class="custom-marker-image" style="width:${adjustedWidth}px;height:30px;transform: rotate(${rotationAngle}deg);" />` +
        `<div class="p-2 my-1" style="position: absolute;top: -20%;font-size: 1rem;color: ${data.aqi >= 151 ? '#fff' : '#000'};">` +
        `<div style="white-space:nowrap;">${this.layerType === 'AQI' ? data.aqi : (this.layerType === 'BARPRESS' ? data.aqiBP : (this.layerType === 'SWDR' ? data.aqiWS : ''))}</div>` +
        `</div>`
    });
  }

  loadMap(event?) {
    this.markers = [];
    let payLoad = { pollutant: 'AQI', state: 'Ras Al Khaimah', layerType: this.layerType };
    if (this.landingPage) {
      payLoad = Object.assign(this.staticJson, payLoad);
    }
    try {
      const request: RequestPayLoadFormat = {
        api: 'publicAqiMap',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        var data: any = []
        if (response.status && response.station_list.length) {
          this.markers = [];
          this.markers = response.station_list;
          data = response.station_list;
          data.forEach(element => {
            element.options = {
              color: 'black',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              text: '' + this.getValue(element)
            };
            const icon = {
              url: '',
              scaledSize: {
                width: 70,
                height: (this.layerType === 'WIND') ? 40 : 30
              }
            };
            switch (element.remark) {
              case 'Good':
                icon.url = 'assets/images/markers/value-good.png';
                break;
              case 'Moderate':
                icon.url = 'assets/images/markers/value-moderate.png';
                break;
              case 'Unhealthy for Sensitive Groups':
                icon.url = 'assets/images/markers/value-satisfactory.png';
                break;
              case 'Unhealthy':
                icon.url = 'assets/images/markers/value-poor.png';
                break;
              case 'Very Unhealthy':
                icon.url = 'assets/images/markers/value-verypoor.png';
                break;
              case 'Hazardous':
                icon.url = 'assets/images/markers/value-severe.png';
                break;
              case 'NA':
                if (this.layerType === 'WIND') {
                  icon.url = 'assets/images/markers/arrow.png';
                } else if (this.layerType === 'BARPRESS' || this.layerType === 'SWDR') {
                  icon.url = 'assets/images/markers/value-moderate.png';
                } else {
                  icon.url = 'assets/images/markers/value-NA.png';
                }
                break;
              default:
                icon.url = 'assets/images/markers/value-NA.png';
                break;
            }
            element.icon = icon;
          });
          this.markers = data
          if (data.length) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].latitude && data[i].latitude.length && data[i].longitude && data[i].longitude.length) {
                this.lat = parseFloat(data[i]['latitude']);
                this.lng = parseFloat(data[i]['longitude']);
                console.log(this.lat, this.lng)
                return;
              }
            }
          }
        } else {
          this.sharedService.serviceErrorMessage(response.message || 'No Data Available');
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  getValue(element) {
    if (this.layerType === 'AQI') {
      return element.aqi ? element.aqi : '';
    } else if (this.layerType === 'WIND') {
      return element.aqiWS;
    } else if (this.layerType === 'BARPRESS') {
      return element.aqiBP;
    } else if (this.layerType === 'SWDR') {
      return element.aqiWS; // aqiWD;
    } else {
      return 'NA';
    }
  }
  fetchAQIMetrics() {
    let payLoad = { standardFormat: '' };
    if (this.landingPage) {
      payLoad = Object.assign(this.staticJson, payLoad);
    }
    try {
      const request: RequestPayLoadFormat = {
        api: 'standard_metadata',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.standards = response.standard_color.AQI;
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  loadGeoJson(event?: any) {
    try {
      const payLoad = {};
      let api: string;
      if (this.appService.DOMAIN_DETAILS().geoJSON) {
        api = this.appService.DOMAIN_DETAILS().geoJSON;
      } else {
        api = 'geoJSON';
      }
      const request: RequestPayLoadFormat = {
        // api: 'geoJSON',
        // api: 'epdaGeoJson',
        api,
        method: 'get',
        loader: true,
        type: 'JSON',
        hideErrorMessage: false,
        payLoad: this.landingPage
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          const responseData = response.data;
          this.geoJsonObject = responseData.geoJSON;
          this.lat = responseData.lat;
          this.lng = responseData.lng;
          this.initMapLeaflet()
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: '#50a3ea', // feature.getProperty('color'),
      strokeWeight: 1,
      stroke: '#50a3ea'
    });
  }
  setStringPadding(str) {
    return ('0' + str).slice(-2);
  }
  getMonth(month) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[month];
  }
  getData(date) {
    try {
      const dt = new Date(date);
      const HH = (dt.getHours() > 9) ? dt.getHours() : ('0' + dt.getHours());
      const MM = (dt.getMinutes() > 9) ? dt.getMinutes() : ('0' + dt.getMinutes());
      const SS = (dt.getSeconds() > 9) ? dt.getSeconds() : ('0' + dt.getSeconds());
      return this.setStringPadding
        (dt.getDate()) + '-' + this.getMonth(dt.getMonth()) + '-' + dt.getFullYear() + ' ' + HH + ':' + MM + ':' + SS;
    } catch (error) {
      Config.logger(error);
    }
  }
  mapMarkerClick(marker) {
    try {
      if (this.layerType === 'AQI') {
        this.markerData = undefined;
        const inputJson = this.selectedMarkerInfo = {
          site: marker.station_id,
          site_id: marker.site_id,
          site_name: marker.site_name,
          site_status: marker.status || marker.station_status,
          graph: 'line',
          station_type: marker.station_name,
          station_type_Name: marker.station_name,
          frequency: '-1day',
          fromDate: this.getData(new Date()),
          pollutant: 'AQI'
        };
        this.selectedMarkerInfo['fromDate'] = this.getData(new Date());
        this.selectedMarkerInfo['responsibleParam'] = marker.responsibleParam;
        this.selectedMarkerInfo['aqi'] = marker.aqi;
        const request: RequestPayLoadFormat = {
          api: 'paramChart',
          method: 'postText',
          loader: true,
          type: 'API',
          hideErrorMessage: false,
          payLoad: inputJson
        };
        this.http.API_REQUEST(request).subscribe(response => {
          if (response && response.status) {
            this.markerData = response;
            this.formatTableData();
            this.activeTab = 'info';
            document.getElementById('markerModal').click();
          } else {
            this.sharedService.serviceErrorMessage(response.message);
          }
        });
      }
    } catch (e) {
      Config.logger(e);
    }
  }
  formatTableData() {
    const tableData = {
      headerContent: [{ label: 'Hour', key: 'hour' }],
      bodyContent: []
    };
    try {
      this.markerData.xAxis.forEach(element => {
        tableData.bodyContent.push({ hour: element });
      });
      this.markerData.Chartdata.forEach((element, index) => {
        tableData.headerContent.push({ label: element.name, key: element.name });
        element.data.forEach((obj, objIndex) => {
          if (tableData.bodyContent[objIndex]) {
            tableData.bodyContent[objIndex][element.name] = obj.value[1];
            tableData.bodyContent[objIndex].color = obj.itemStyle.color;
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
    this.markerData.tableData = tableData;
  }
  onMouseOver(infoWindow) {
    infoWindow.open();
  }
  onMouseOut(infoWindow) {
    infoWindow.close();
  }
  navigateToLoginPage() {
    this.router.navigate(['/user-login']);
  }

  /**
   * To show aqi layers in map or not
   */
  isAqiLayersFn() {
    try {
      const data = this.appService.DOMAIN_DETAILS();
      if (data.aqiDashboardMapLayers) {
        this.isAqiLayers = data.aqiDashboardMapLayers;
      } else {
        this.isAqiLayers = false;
      }
    } catch (error) {
      Config.logger(error);
    }
  }

}
